import React from "react";
import AiAssessmentCodingScreen from "../aiAssessmentCodingScreen/AiAssessmentCodingScreen";
import "./aiAssessmentAnswerInputs.scss";

interface CodingAnswerInputProps {
  handleCodingFullscreenToggle: () => void;
  isCodingFullscreen: boolean;
}

const CodingAnswerInput: React.FC<CodingAnswerInputProps> = ({
  handleCodingFullscreenToggle,
  isCodingFullscreen,
}) => {
  return (
    <div className="coding-answer-input">
      <AiAssessmentCodingScreen
        handleCodingFullscreenToggle={handleCodingFullscreenToggle}
        isCodingFullscreen={isCodingFullscreen}
      />
    </div>
  );
};

export default CodingAnswerInput;
